import { Promotion } from '@/common/models/carousel/carousel-success.response';
import { Component, Inject, Input, ViewEncapsulation } from '@angular/core';

@Component({
    selector: 'fe-card-promotion',
    templateUrl: './card-promotion.component.html',
    styleUrls: ['./card-promotion.component.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class CardPromotionComponent {
    @Input() promotion: Promotion | any;

    constructor(
        @Inject('DATE_FORMAT_PROGRESS_BAR')
        public dateFormatProgressBar: string,
    ) {}
}
